'use strict';

/**
* Check if a specific bootstrap breakpoint is visible
*
* @param {string} breakpoint - The bootstrap view name. Possible values: xs, sm, md, lg, xl
* @returns {boolean} - True if the breakpoint is visible
*/
function checkBreakpoint(breakpoint) {
    return $('.device-' + breakpoint).css('display') === 'block';
}

/**
* Check if sm or xs breakpoint are currently visible
*
* @returns {boolean} - True is sm or xs breakpoint is visible
*/
function checkMobileBreakpoints() {
    if (checkBreakpoint('sm') || checkBreakpoint('xs')) {
        return true;
    }
    return false;
}

module.exports = {
    isMobileView: function () {
        return checkMobileBreakpoints();
    },

    isDesktopView: function () {
        return !checkMobileBreakpoints();
    },

    /**
     * Check is any of the breakpoints are visible
     *
     * @example isCurrentBreakpoint('xs', 'sm')
     * @param {arguments} breakpoints One or more breakpoint parameters. Options are: xs, sm, md, lg, xl
     * @returns {boolean} - True if any of the breakpoints are the current breakpoint.
     */
    isCurrentBreakpoint: function () {
        if (arguments.length === 0) {
            throw new Error('No parameters specified');
        }

        for (var i = 0, len = arguments.length; i < len; i++) {
            var breakpoint = arguments[i];

            if (checkBreakpoint(breakpoint)) {
                return true;
            }
        }

        return false;
    }
};
